const { levels, colors, logLevel, stderrLevels } = require('./logger-common');

const logLevelInt = levels[logLevel];
const browserColors = { ...colors, FATAL: 'red; font-weight: bold' };
const devLog = process.env.NODE_ENV !== 'production';

const log = (level, msg, data) => {
	/* eslint-disable no-console */
	if (devLog && levels[level] <= logLevelInt) {
		const color = `color: ${browserColors[level]}`;
		const outputStream = stderrLevels.has(level)
			? console.error
			: console.log;
		outputStream(`%c${level} : ${msg}`, color);
		if (data) {
			outputStream(`%c${JSON.stringify(data, undefined, 4)}`, color);
		}
	}
	/* eslint-enable no-console */
};

module.exports = {
	log
};
